export default "__VITE_ASSET__tf5mQ3ir__"